// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IVerificationCodeValidationResponseDto
 */
export interface IVerificationCodeValidationResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof IVerificationCodeValidationResponseDto
     */
    verified?: boolean;
}

/**
 * Check if a given object implements the IVerificationCodeValidationResponseDto interface.
 */
export function instanceOfIVerificationCodeValidationResponseDto(value: object): value is IVerificationCodeValidationResponseDto {
    return true;
}

export function IVerificationCodeValidationResponseDtoFromJSON(json: any): IVerificationCodeValidationResponseDto {
    return IVerificationCodeValidationResponseDtoFromJSONTyped(json, false);
}

export function IVerificationCodeValidationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IVerificationCodeValidationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'verified': json['verified'] == null ? undefined : json['verified'],
    };
}

export function IVerificationCodeValidationResponseDtoToJSON(json: any): IVerificationCodeValidationResponseDto {
    return IVerificationCodeValidationResponseDtoToJSONTyped(json, false);
}

export function IVerificationCodeValidationResponseDtoToJSONTyped(value?: IVerificationCodeValidationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'verified': value['verified'],
    };
}

